module.exports = __webpack_public_path__ + "img/current_leave.e8d8cf20.png";